/**
 * @generated SignedSource<<41c111e5ceffa68f598d059560399728>>
 * @relayHash 37691a2ea664ea608db989394f721e35
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 407f5fad955448e52028e8ed34ed859ba18b22105591ba90774abd111cde418c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CreateIntentTemplatesSideBarQuery } from './CreateIntentTemplatesSideBarQuery.graphql';

const node: PreloadableConcreteRequest<CreateIntentTemplatesSideBarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "407f5fad955448e52028e8ed34ed859ba18b22105591ba90774abd111cde418c",
    "metadata": {},
    "name": "CreateIntentTemplatesSideBarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
